import { createAction } from "redux-actions";

/// //////////////////////////Service///////////////////////////////////

export const FETCH_SERVICE_BY_USERID = "FETCH_SERVICE_BY_USERID";
export const fetchServiceByUserId = createAction(FETCH_SERVICE_BY_USERID);

export const FETCH_SERVICE_BY_USERID_FAILURE = "FETCH_SERVICE_BY_USERID_FAILURE";
export const fetchServiceByUserIdFailure = createAction(FETCH_SERVICE_BY_USERID_FAILURE);

export const FETCH_SERVICE_BY_USERID_REQUESTED = "FETCH_SERVICE_BY_USERID_REQUESTED";
export const fetchServiceByUserIdRequested = createAction(FETCH_SERVICE_BY_USERID_REQUESTED);

export const FETCH_SERVICE_BY_USERID_SUCCESS = "FETCH_SERVICE_BY_USERID_SUCCESS";
export const fetchServiceByUserIdSuccess = createAction(FETCH_SERVICE_BY_USERID_SUCCESS);

/// /////////////////////////// Product///////////////////////////////
export const FETCH_PRODUCT_BY_USERID = "FETCH_PRODUCT_BY_USERID";
export const fetchProductByUserId = createAction(FETCH_PRODUCT_BY_USERID);

export const FETCH_PRODUCT_BY_USERID_FAILURE = "FETCH_PRODUCT_BY_USERID_FAILURE";
export const fetchProductByUserIdFailure = createAction(FETCH_PRODUCT_BY_USERID_FAILURE);

export const FETCH_PRODUCT_BY_USERID_REQUESTED = "FETCH_PRODUCT_BY_USERID_REQUESTED";
export const fetchProductByUserIdRequested = createAction(FETCH_PRODUCT_BY_USERID_REQUESTED);

export const FETCH_PRODUCT_BY_USERID_SUCCESS = "FETCH_PRODUCT_BY_USERID_SUCCESS";
export const fetchProductByUserIdSuccess = createAction(FETCH_PRODUCT_BY_USERID_SUCCESS);

/// //////////////////////////Add Service/Product ///////////////////////////////////
export const ADD_SERVICE_PRODUCT = "ADD_SERVICE_PRODUCT";
export const addServiceProduct = createAction(ADD_SERVICE_PRODUCT);

export const ADD_SERVICE_PRODUCT_FAILURE = "ADD_SERVICE_PRODUCT_FAILURE";
export const addServiceProductFailure = createAction(ADD_SERVICE_PRODUCT_FAILURE);

export const ADD_SERVICE_PRODUCT_REQUESTED = "ADD_SERVICE_PRODUCT_REQUESTED";
export const addServiceProductRequested = createAction(ADD_SERVICE_PRODUCT_REQUESTED);

export const ADD_SERVICE_PRODUCT_SUCCESS = "ADD_SERVICE_PRODUCT_SUCCESS";
export const addServiceProductSuccess = createAction(ADD_SERVICE_PRODUCT_SUCCESS);

/// ///////////////////////////////Update Product Service //////////////////
export const UPDATE_SERVICE_BY_USERID = "UPDATE_SERVICE_BY_USERID";
export const updateProductByUserId = createAction(UPDATE_SERVICE_BY_USERID);

export const UPDATE_SERVICE_BY_USERID_FAILURE = "UPDATE_SERVICE_BY_USERID_FAILURE";
export const updateProductByUserIdFailure = createAction(UPDATE_SERVICE_BY_USERID_FAILURE);

export const UPDATE_SERVICE_BY_USERID_REQUESTED = "UPDATE_SERVICE_BY_USERID_REQUESTED";
export const updateProductByUserIdRequested = createAction(UPDATE_SERVICE_BY_USERID_REQUESTED);

export const UPDATE_SERVICE_BY_USERID_SUCCESS = "UPDATE_SERVICE_BY_USERID_SUCCESS";
export const updateProductByUserIdSuccess = createAction(UPDATE_SERVICE_BY_USERID_SUCCESS);

/// ///////////////////////////////Update Product Service //////////////////
export const GET_ACCEPTED_DELIVERED = "GET_ACCEPTED_DELIVERED";
export const getAcceptedDeliveredService = createAction(GET_ACCEPTED_DELIVERED);

export const GET_ACCEPTED_DELIVERED_FAILURE = "GET_ACCEPTED_DELIVERED_FAILURE";
export const getAcceptedDeliveredFailure = createAction(GET_ACCEPTED_DELIVERED_FAILURE);

export const GET_ACCEPTED_DELIVERED_REQUESTED = "GET_ACCEPTED_DELIVERED_REQUESTED";
export const getAcceptedDeliveredRequested = createAction(GET_ACCEPTED_DELIVERED_REQUESTED);

export const GET_ACCEPTED_DELIVERED_SUCCESS = "GET_ACCEPTED_DELIVERED_SUCCESS";
export const getAcceptedDeliveredSuccess = createAction(GET_ACCEPTED_DELIVERED_SUCCESS);

// -------------------------------------------FAVOURITE BUISNESS ----------------------------------
export const GET_FAVOURITE_BUSINESS = "GET_FAVOURITE_BUSINESS";
export const getFavouriteBuisness = createAction(GET_FAVOURITE_BUSINESS);

export const GET_FAVOURITE_BUSINESS_FAILURE = "GET_FAVOURITE_BUSINESS_FAILURE";
export const getFavouriteBuisnessFailure = createAction(GET_FAVOURITE_BUSINESS_FAILURE);

export const GET_FAVOURITE_BUSINESS_REQUESTED = "GET_FAVOURITE_BUSINESS_REQUESTED";
export const getFavouriteBuisnessRequested = createAction(GET_FAVOURITE_BUSINESS_REQUESTED);

export const GET_FAVOURITE_BUSINESS_SUCCESS = "GET_FAVOURITE_BUSINESS_SUCCESS";
export const getFavouriteBuisnessSuccess = createAction(GET_FAVOURITE_BUSINESS_SUCCESS);

export const ADD_FAVOURITE_BUSINESS = "ADD_FAVOURITE_BUSINESS";
export const addFavouriteBuisness = createAction(ADD_FAVOURITE_BUSINESS);

export const ADD_FAVOURITE_BUSINESS_FAILURE = "ADD_FAVOURITE_BUSINESS_FAILURE";
export const addFavouriteBuisnessFailure = createAction(ADD_FAVOURITE_BUSINESS_FAILURE);

export const ADD_FAVOURITE_BUSINESS_REQUESTED = "ADD_FAVOURITE_BUSINESS_REQUESTED";
export const addFavouriteBuisnessRequested = createAction(ADD_FAVOURITE_BUSINESS_REQUESTED);

export const ADD_FAVOURITE_BUSINESS_SUCCESS = "ADD_FAVOURITE_BUSINESS_SUCCESS";
export const addFavouriteBuisnessSuccess = createAction(ADD_FAVOURITE_BUSINESS_SUCCESS);

export const ADD_UN_FAVOURITE_BUSINESS = "ADD_UN_FAVOURITE_BUSINESS";
export const addUnFavouriteBuisness = createAction(ADD_UN_FAVOURITE_BUSINESS);

export const ADD_UN_FAVOURITE_BUSINESS_FAILURE = "ADD_UN_FAVOURITE_BUSINESS_FAILURE";
export const addUnFavouriteBuisnessFailure = createAction(ADD_UN_FAVOURITE_BUSINESS_FAILURE);

export const ADD_UN_FAVOURITE_BUSINESS_REQUESTED = "ADD_UN_FAVOURITE_BUSINESS_REQUESTED";
export const addUnFavouriteBuisnessRequested = createAction(ADD_UN_FAVOURITE_BUSINESS_REQUESTED);

export const ADD_UN_FAVOURITE_BUSINESS_SUCCESS = "ADD_UN_FAVOURITE_BUSINESS_SUCCESS";
export const addUnFavouriteBuisnessSuccess = createAction(ADD_UN_FAVOURITE_BUSINESS_SUCCESS);

// -------------------------------------------RECOMMENDED SERVICE----------------------------------
export const GET_RECOMMENDED_SERVICE = "GET_RECOMMENDED_SERVICE";
export const getRecommendedService = createAction(GET_RECOMMENDED_SERVICE);

export const GET_RECOMMENDED_SERVICE_FAILURE = "GET_RECOMMENDED_SERVICE_FAILURE";
export const getRecommendedServiceFailure = createAction(GET_RECOMMENDED_SERVICE_FAILURE);

export const GET_RECOMMENDED_SERVICE_REQUESTED = "GET_RECOMMENDED_SERVICE_REQUESTED";
export const getRecommendedServiceRequested = createAction(GET_RECOMMENDED_SERVICE_REQUESTED);

export const GET_RECOMMENDED_SERVICE_SUCCESS = "GET_RECOMMENDED_SERVICE_SUCCESS";
export const getRecommendedServiceSuccess = createAction(GET_RECOMMENDED_SERVICE_SUCCESS);
